import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Building2, Package, Users, LogOut, Key, X, FileText, Activity } from 'lucide-react';
import Login from './Login';
import FirmaYonetimi from './FirmaYonetimi';
import TupYonetimi from './TupYonetimi';
import KullaniciYonetimi from './KullaniciYonetimi';
import AlarmPaneli from './AlarmPaneli';
import AlarmSayfasi from './AlarmSayfasi';
import Hareketler from './Hareketler';
import api from './config';

function App() {
    const [user, setUser] = useState(() => {
        const saved = localStorage.getItem('user');
        return saved ? JSON.parse(saved) : null;
    });

    const handleLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setUser(null);
    };

    if (!user) {
        return <Login onLogin={setUser} />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Dashboard user={user} onLogout={handleLogout} />} />
                <Route path="/firmalar" element={user.rol !== 'Müşteri' ? <FirmaYonetimi user={user} /> : <NoAccess />} />
                <Route path="/tupler" element={<TupYonetimi user={user} />} />
                <Route path="/kullanicilar" element={user.rol === 'Admin' ? <KullaniciYonetimi /> : <NoAccess />} />
                <Route path="/alarmlar" element={<AlarmSayfasi user={user} />} />
                <Route path="/hareketler" element={user.rol === 'Admin' ? <Hareketler /> : <NoAccess />} />
            </Routes>
        </BrowserRouter>
    );
}

function NoAccess() {
    return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
            <h2>🚫 Erişim Engellendi</h2>
            <p>Bu sayfaya erişim yetkiniz bulunmamaktadır.</p>
            <Link to="/" style={{ color: '#3b82f6' }}>Ana Sayfaya Dön</Link>
        </div>
    );
}

function Dashboard({ user, onLogout }) {
    const [firmalar, setFirmalar] = React.useState([]);
    const [sifreModal, setSifreModal] = React.useState(false);
    const [sifreForm, setSifreForm] = React.useState({ eskiSifre: '', yeniSifre: '', yeniSifreTekrar: '' });
    const [sifreHata, setSifreHata] = React.useState('');
    const [sifreBasari, setSifreBasari] = React.useState('');
    const [hareketler, setHareketler] = React.useState([]);
    const [istatistikler, setIstatistikler] = React.useState({ ekleme: 0, guncelleme: 0, pasif: 0, bakim: 0 });

    React.useEffect(() => {
        api.get('/api/firmalar').then(res => setFirmalar(res.data));
        if (user.rol === 'Admin') {
            fetchHareketler();
        }
    }, [user.rol]);

    const fetchHareketler = async () => {
        try {
            const res = await api.get('/api/hareketler?limit=50');
            setHareketler(res.data);
            // İstatistikleri hesapla
            const stats = { ekleme: 0, guncelleme: 0, pasif: 0, bakim: 0 };
            res.data.forEach(h => {
                if (h.islem_tipi === 'Ekleme') stats.ekleme++;
                if (h.islem_tipi === 'Güncelleme') stats.guncelleme++;
                if (h.islem_tipi === 'Pasif') stats.pasif++;
                if (h.islem_tipi === 'Bakım') stats.bakim++;
            });
            setIstatistikler(stats);
        } catch (err) {
            console.error('Hareketler yüklenemedi:', err);
        }
    };

    const handleSifreDegistir = async () => {
        setSifreHata('');
        setSifreBasari('');
        if (sifreForm.yeniSifre !== sifreForm.yeniSifreTekrar) {
            setSifreHata('Yeni şifreler eşleşmiyor');
            return;
        }
        if (sifreForm.yeniSifre.length < 6) {
            setSifreHata('Şifre en az 6 karakter olmalı');
            return;
        }
        try {
            await api.post('/api/kullanici/sifre-degistir', {
                eski_sifre: sifreForm.eskiSifre,
                yeni_sifre: sifreForm.yeniSifre
            });
            setSifreBasari('Şifre başarıyla değiştirildi');
            setTimeout(() => { setSifreModal(false); setSifreForm({ eskiSifre: '', yeniSifre: '', yeniSifreTekrar: '' }); setSifreBasari(''); }, 1500);
        } catch (err) {
            setSifreHata(err.response?.data?.detail || 'Şifre değiştirme başarısız');
        }
    };

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>

                {/* ŞİFRE DEĞİŞTİRME MODAL */}
                {sifreModal && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                        <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', width: '400px', maxWidth: '90%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h3 style={{ margin: 0 }}>🔐 Şifre Değiştir</h3>
                                <button onClick={() => setSifreModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} /></button>
                            </div>
                            {sifreHata && <div style={{ backgroundColor: '#fef2f2', color: '#dc2626', padding: '10px', borderRadius: '8px', marginBottom: '15px' }}>{sifreHata}</div>}
                            {sifreBasari && <div style={{ backgroundColor: '#f0fdf4', color: '#16a34a', padding: '10px', borderRadius: '8px', marginBottom: '15px' }}>{sifreBasari}</div>}
                            <input type="password" placeholder="Mevcut Şifre" value={sifreForm.eskiSifre} onChange={e => setSifreForm({ ...sifreForm, eskiSifre: e.target.value })} style={{ width: '100%', padding: '12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }} />
                            <input type="password" placeholder="Yeni Şifre" value={sifreForm.yeniSifre} onChange={e => setSifreForm({ ...sifreForm, yeniSifre: e.target.value })} style={{ width: '100%', padding: '12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }} />
                            <input type="password" placeholder="Yeni Şifre (Tekrar)" value={sifreForm.yeniSifreTekrar} onChange={e => setSifreForm({ ...sifreForm, yeniSifreTekrar: e.target.value })} style={{ width: '100%', padding: '12px', marginBottom: '20px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }} />
                            <button onClick={handleSifreDegistir} style={{ ...btnStyle, backgroundColor: '#3b82f6', width: '100%', justifyContent: 'center' }}>Şifreyi Değiştir</button>
                        </div>
                    </div>
                )}

                {/* HEADER */}
                <div style={{ ...panelStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <strong style={{ fontSize: '20px' }}>🔥 Yangın Tüp Takip</strong>
                        <span style={{ marginLeft: '15px', color: '#6b7280' }}>{user.email} ({user.rol})</span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={() => setSifreModal(true)} style={{ ...btnStyle, backgroundColor: '#6b7280' }}>
                            <Key size={16} /> Şifre Değiştir
                        </button>
                        <button onClick={onLogout} style={{ ...btnStyle, backgroundColor: '#ef4444' }}>
                            <LogOut size={16} /> Çıkış
                        </button>
                    </div>
                </div>

                {/* MENÜ KARTLARI */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '20px' }}>

                    {user.rol !== 'Müşteri' && (
                        <Link to="/firmalar" style={{ textDecoration: 'none' }}>
                            <div style={cardStyle}>
                                <Building2 size={48} color="#8b5cf6" />
                                <h3 style={{ margin: '15px 0 5px' }}>Firma Yönetimi</h3>
                                <p style={{ color: '#6b7280', margin: 0 }}>Firmaları görüntüle, ekle ve düzenle</p>
                            </div>
                        </Link>
                    )}

                    <Link to="/tupler" style={{ textDecoration: 'none' }}>
                        <div style={cardStyle}>
                            <Package size={48} color="#3b82f6" />
                            <h3 style={{ margin: '15px 0 5px' }}>Tüp Yönetimi</h3>
                            <p style={{ color: '#6b7280', margin: 0 }}>Tüpleri görüntüle, ekle ve düzenle</p>
                        </div>
                    </Link>

                    {user.rol === 'Admin' && (
                        <Link to="/kullanicilar" style={{ textDecoration: 'none' }}>
                            <div style={cardStyle}>
                                <Users size={48} color="#10b981" />
                                <h3 style={{ margin: '15px 0 5px' }}>Kullanıcı Yönetimi</h3>
                                <p style={{ color: '#6b7280', margin: 0 }}>Kullanıcıları görüntüle, ekle ve düzenle</p>
                            </div>
                        </Link>
                    )}

                    {user.rol === 'Admin' && (
                        <Link to="/hareketler" style={{ textDecoration: 'none' }}>
                            <div style={cardStyle}>
                                <FileText size={48} color="#f59e0b" />
                                <h3 style={{ margin: '15px 0 5px' }}>Sistem Hareketleri</h3>
                                <p style={{ color: '#6b7280', margin: 0 }}>Tüm işlemleri görüntüle (Audit Log)</p>
                            </div>
                        </Link>
                    )}

                </div>

                {/* ÖZET BİLGİLER */}
                <div style={{ ...panelStyle, marginTop: '20px' }}>
                    <h3 style={{ marginTop: 0 }}>📊 Özet</h3>
                    <div style={{ display: 'flex', gap: '30px' }}>
                        <div>
                            <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#8b5cf6' }}>{firmalar.length}</span>
                            <p style={{ margin: 0, color: '#6b7280' }}>Firma</p>
                        </div>
                    </div>
                </div>

                {/* İSTATİSTİKLER (SADECE ADMİN) */}
                {user.rol === 'Admin' && hareketler.length > 0 && (
                    <div style={{ ...panelStyle, marginTop: '20px' }}>
                        <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Activity size={24} color="#f59e0b" />
                            Son İşlemler (Son 50)
                        </h3>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#f0fdf4', borderRadius: '8px' }}>
                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#10b981' }}>{istatistikler.ekleme}</div>
                                <div style={{ fontSize: '14px', color: '#6b7280' }}>Ekleme</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#eff6ff', borderRadius: '8px' }}>
                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#3b82f6' }}>{istatistikler.guncelleme}</div>
                                <div style={{ fontSize: '14px', color: '#6b7280' }}>Güncelleme</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#fef2f2', borderRadius: '8px' }}>
                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#ef4444' }}>{istatistikler.pasif}</div>
                                <div style={{ fontSize: '14px', color: '#6b7280' }}>Pasif</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#fffbeb', borderRadius: '8px' }}>
                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#f59e0b' }}>{istatistikler.bakim}</div>
                                <div style={{ fontSize: '14px', color: '#6b7280' }}>Bakım</div>
                            </div>
                        </div>
                        <div style={{ marginTop: '15px' }}>
                            <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Son 10 Hareket</h4>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', fontSize: '13px' }}>
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                            <th style={{ padding: '8px', textAlign: 'left' }}>Tarih</th>
                                            <th style={{ padding: '8px', textAlign: 'left' }}>İşlem</th>
                                            <th style={{ padding: '8px', textAlign: 'left' }}>Kullanıcı</th>
                                            <th style={{ padding: '8px', textAlign: 'left' }}>Açıklama</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hareketler.slice(0, 10).map((h) => (
                                            <tr key={h.hareket_id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                <td style={{ padding: '8px' }}>
                                                    {new Date(h.islem_tarihi).toLocaleString('tr-TR', {
                                                        month: 'short',
                                                        day: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}
                                                </td>
                                                <td style={{ padding: '8px' }}>
                                                    <span style={{
                                                        backgroundColor: h.islem_tipi === 'Ekleme' ? '#10b98120' :
                                                                       h.islem_tipi === 'Güncelleme' ? '#3b82f620' :
                                                                       h.islem_tipi === 'Pasif' ? '#ef444420' : '#f59e0b20',
                                                        color: h.islem_tipi === 'Ekleme' ? '#10b981' :
                                                               h.islem_tipi === 'Güncelleme' ? '#3b82f6' :
                                                               h.islem_tipi === 'Pasif' ? '#ef4444' : '#f59e0b',
                                                        padding: '2px 8px',
                                                        borderRadius: '8px',
                                                        fontSize: '12px'
                                                    }}>
                                                        {h.islem_tipi}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '8px', color: '#6b7280' }}>
                                                    {h.kullanici_email?.split('@')[0] || 'Sistem'}
                                                </td>
                                                <td style={{ padding: '8px', color: '#6b7280' }}>{h.aciklama}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ marginTop: '15px', textAlign: 'center' }}>
                                <Link to="/hareketler" style={{ ...btnStyle, backgroundColor: '#f59e0b', textDecoration: 'none', display: 'inline-flex' }}>
                                    <FileText size={16} /> Tüm Hareketleri Görüntüle
                                </Link>
                            </div>
                        </div>
                    </div>
                )}

                {/* ALARM PANELİ */}
                <div style={{ marginTop: '20px' }}>
                    <AlarmPaneli user={user} />
                </div>

            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '20px' };
const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center', cursor: 'pointer', transition: 'transform 0.2s', color: '#1f2937' };
const btnStyle = { color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' };

export default App;